import { render, staticRenderFns } from "./induction_value.vue?vue&type=template&id=0e018ffe&scoped=true&"
import script from "./induction_value.vue?vue&type=script&lang=js&"
export * from "./induction_value.vue?vue&type=script&lang=js&"
import style0 from "./induction_value.vue?vue&type=style&index=0&id=0e018ffe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e018ffe",
  null
  
)

export default component.exports